/**
 * Set Cloudinary instance
 *
 * @tutorial https://cloudinary.com/documentation/javascript_integration
 */
import { Cloudinary } from '@cloudinary/url-gen';
import { CloudinaryMediaView } from '../types';

/**
 * Optional CDN hostname placed in front of Cloudinary (e.g. img.utmb.world → Bunny pull zone
 * whose origin is https://res.cloudinary.com/<cloudName>).
 * When set, generated URLs become https://<host>/image/upload/... (no cloud name segment).
 * When unset, URLs target res.cloudinary.com directly (previous behaviour).
 */
const cdnHost = process.env.NEXT_PUBLIC_CLOUDINARY_HOST;

// Create instance
const cloudinary: Cloudinary = new Cloudinary({
    cloud: {
        cloudName: process.env.NEXT_PUBLIC_CLOUDINARY_NAME ?? 'utmb-world',
    },
    url: {
        secure: true,
        ...(cdnHost ? { secureDistribution: cdnHost, privateCdn: true } : {}),
    },
});

/**
 * Convert a publicID string to a publicID cloudinaryMediaView object
 *
 * @param publicId Public ID to use to get the Cloudinary image
 * @param alt: Alternate text to use
 *
 * @returns The needed object to get the Cloudinary image
 */
export function pIdToCloudinary(publicId: string, alt: string): CloudinaryMediaView {
    return { publicId, alt } as CloudinaryMediaView;
}

export default cloudinary;
export { Cloudinary };
